<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div id="Incident">
    <MyHeaderPage
      :title="$t('ticketsList.Incident.title')"
      :subtitle="$t('ticketsList.Incident.subTitle')"
    />
    <br /><br />
    <TicketTable
      :service="IncidentService"
      :mobile-component="IncidentCard"
      detail-url-key="nav.reportIncidentListUrl"
      i18n-namespace="ticketsList.Incident"
      show-severity
    />
  </div>
</template>

<script setup>
import { getCurrentInstance, onMounted } from 'vue'
import MyHeaderPage from '@/components/MyHeaderPage.vue'
import TicketTable from '@/components/Feature/Ticket/TicketTable.vue'
import IncidentCard from '@/components/Incident/IncidentCard.vue'
import { IncidentService } from '@/services/IncidentService'
import '@/assets/scss/Incident.scss'

const { proxy } = getCurrentInstance()

onMounted(() => {
  window.scrollTo(0, 0)
  proxy.$IsLoggedIn()
})
</script>
